import { MockFactory } from '@tino-frontend/mocks'
import { PaymentLink, PaymentLinkStatus } from '@types'

const expirationDate = new Date()
expirationDate.setDate(expirationDate.getDate() + 5)

export const paymentLinkPendingNFeMock = new MockFactory<PaymentLink>({
  id: 'payment-link-id-pending-nfe',
  created_at: '2023-07-07T19:24:23.721429Z',
  limit_reservation: {
    created_at: '2023-07-07T19:24:23.721429Z',
    expiration_date: expirationDate.toISOString(),
  },
  external_id: 'external-id',
  status: PaymentLinkStatus.PendingNFe,
  merchant_name: 'Culinary Delights Co.',
  amount_cents: 2000,
})
